import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, checkoutUrl } from '../data/content';
export function Guarantee() {
  return <section className="w-full bg-stone-50 py-16 md:py-24" data-id="element-81" data-mp="22369pwlsw9tu">
      <div className="mx-auto w-full max-w-3xl px-5 text-center md:px-8" data-id="element-82" data-mp="222n0r5e4ovry">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-pink-600 text-white" data-id="element-83" data-mp="1x5mvuxt0lz2f">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-84" data-mp="19fad0rw8ehx2" />
        </span>

        <h2 className="mt-7 text-3xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-5xl" data-id="element-85" data-mp="14gz4qlll4fgy">
          Garanzia di 7 giorni
        </h2>

        <div className="mt-9 rounded-2xl bg-white px-6 py-9 shadow-sm ring-1 ring-neutral-200 md:px-10" data-id="element-86" data-mp="1edtzquinfxqh">
          <p className="text-lg leading-relaxed text-neutral-500 md:text-xl" data-id="element-87" data-mp="qnzrkq99yxck">
            Puoi accedere al{' '}
            <span className="font-extrabold text-neutral-800" data-id="element-88" data-mp="lpy8i5bumy13">{brand.name}</span> e verificare
            con calma se è adatto alle tue esigenze.
          </p>
          <p className="mt-6 text-lg font-extrabold leading-snug tracking-tight text-neutral-800 md:text-xl" data-id="element-89" data-mp="oxp1i0q6f2zu">
            Se non dovesse fare al caso tuo, contattaci entro 7 giorni dall’acquisto, secondo le
            condizioni della nostra garanzia.
          </p>

          <div className="mt-8" data-id="element-90" data-mp="12qeoo8hfydyj">
            <CtaButton variant="secondary" size="md" href={checkoutUrl} data-id="element-91" data-mp="12sr2qak2w46b">
              Accedi al Kit Ottobre Rosa
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}